export class Primary {
  constructor() {
    this.name = 'Primary'
    this.content =  {
      text: 'Lorem ipsum dolor sit amet.'
    }
    this.view = this.viewHtml()
  }

  viewHtml() {
    return `Lorem ipsum dolor sit amet`
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      styles: {
        desktop: [],
        tablet: [],
        phone: []
      },
      classes: {
        desktop: [],
        tablet: [],
        phone: []
      },
    }
  }
}